'use strict';

var syncTime = require('../../../../../../motion-dom/dist/es/frameloop/sync-time.cjs');
var frame = require('../../../../../../motion-dom/dist/es/frameloop/frame.cjs');

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = syncTime.time.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            frame.cancelFrame(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    frame.frame.setup(checkElapsed, true);
    return () => frame.cancelFrame(checkElapsed);
}

exports.delay = delay;
//# sourceMappingURL=delay.cjs.map
